import { Input } from "reactstrap";

const InputSearch = ({
  searchValueFilter,
  setSearchValueFilter,
  placeholderSearch,
}) => {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Input
        type="text"
        placeholder={placeholderSearch}
        onChange={(e) => setSearchValueFilter(e.target.value)}
        value={searchValueFilter}
        style={{ paddingLeft: "40px" }}
      />
      <i
        className="fas fa-search"
        style={{
          position: "absolute",
          marginLeft: "5px",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#888",
          pointerEvents: "none",
          background: "transparent",
          border: "none",
          fontSize: "14px",
        }}
      />
      {searchValueFilter?.length > 0 && (
        <button
          type="button"
          onClick={() => setSearchValueFilter("")}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            color: "#888",
          }}
        >
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>
  );
};

export default InputSearch;
